import { z } from 'zod/v4';

export const ORDER_DOCUMENT_ORIGIN_VALUES = [
  'TRACING',
  'ORDER_HUB',
  'CMM',
] as const;

export const OrderDocumentResourceSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    documentType: z.string().nullable(),
    documentTypeId: z.string().nullable(),
    origin: z.enum(ORDER_DOCUMENT_ORIGIN_VALUES),
    orderLineId: z.string().nullable(),
    fileId: z.string().nullable(),
    fileUrl: z.string().nullable(),
    fileContentType: z.string().nullable(),
    updatedAt: z.string().nullable(),
    createdAt: z.string().nullable(),
  })
  .strict();

export type OrderDocumentResource = z.infer<typeof OrderDocumentResourceSchema>;
